import * as qs from '@/ui/queryState';

export function usePagination(perPageFallback = 20) {
  const page = qs.number('page', 1);
  const perPage = qs.number('perPage', perPageFallback);

  const resetPagination = () => {
    page.value = 1;
  };

  return {
    page,
    perPage,
    resetPagination,
  };
}
